import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, debounceTime } from 'rxjs';
import { CargoService } from 'src/app/shared/service/disbursment/cargo.service';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { MaCargo } from '../../../dis-repository/pages/create-cargo/cargo.model';
import { CreateCargoComponent } from '../../../dis-repository/pages/create-cargo/create-cargo.component';
import { ToastrService } from 'ngx-toastr';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-cargo',
  templateUrl: './cargo.component.html',
  styleUrls: ['./cargo.component.scss']
})
export class CargoComponent {
 private loader = inject(DisbursmentService);
 isLoading$ = this.loader.loading$;
  searchTerm: string = '';
  displayedColumns: string[] = ['Sl.No', 'type', 'Action'];
  dataSource = new MatTableDataSource<MaCargo>();

  currentPage = 1;
  pageSize = 50;
  totalCount = 0;
  allDataLoaded = false;
  private searchSubject = new Subject<string>();

  constructor(
    private dialog: MatDialog,
    private cargoService: CargoService,
    private snackBar: ToastrService,
    private requestFormService: RequestFormService,
  ) { this.loader.hide(); }

  ngOnInit() {
    this.getMaCargoDataFromDb(true);

    // Setup debounce for search
    this.searchSubject
      .pipe(
        debounceTime(1000)
      )
      .subscribe(() => {
        this.onSearch();
      });
  }

  ngOnDestroy() {
    this.searchSubject.complete();
  }

  inputSearch(): void {
    if (this.searchTerm.trim() === '') {
      this.onSearch();
    } else {
      this.searchSubject.next(this.searchTerm);
    }
  }

  // method to search the record globally
  onSearch(): void {
    this.getMaCargoDataFromDb(true);
  }

  // method to  clear the search term
  clearSearch(): void {
    this.searchTerm = '';
    this.getMaCargoDataFromDb(true);
  }

  // method to call the api on scroll
  onManualScroll(): void {
    const scrollContainer = document.querySelector('.table-container');
    if (scrollContainer) {
      const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
      const scrollHeight = scrollContainer.scrollHeight;

      if (
        scrollPosition >= scrollHeight - 10 &&
        !this.loader.loading$ &&
        !this.allDataLoaded
      ) {
        this.getMaCargoDataFromDb();
      }
    }
  }

  getMaCargoDataFromDb(reset = false): void {
    if (reset) {
      this.currentPage = 1;
      this.allDataLoaded = false;
      this.dataSource.data = [];
      this.totalCount = 0;
    }

    const body = {
      page: this.currentPage,
      page_size: this.pageSize,
      query: this.searchTerm.trim(),
    };

    this.loader.show();

    this.cargoService.CargoDataFromDb(body).subscribe({
      next: (response: { data: MaCargo[]; total_count: number }) => {
        const newData = response.data;
        this.totalCount = response.total_count;

        this.dataSource.data = [...this.dataSource.data, ...newData];

        if (this.dataSource.data.length >= this.totalCount) {
          this.allDataLoaded = true;
        }

        this.currentPage++;
        this.loader.hide();
      },
      error: () => {
        this.snackBar.error("Something went wrong. Please try again later.");
        this.loader.hide();
      }
    });
  }

  openAddCargoDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];

    const dialogRef = this.dialog.open(CreateCargoComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
        this.getMaCargoDataFromDb(true);
      }
    });
  }

  openEditCargoDialog(rowData: MaCargo): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.data = { rowData };
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];

    const dialogRef = this.dialog.open(CreateCargoComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
        this.getMaCargoDataFromDb(true);
      }
    });
  }
      isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
